import { type RouteObject } from 'react-router';

import { metadataRoute, pushRoute } from '@@components/Page/detailViewRoutes';
import { ErrorPage } from '@@containers/App/ErrorPage';

export const routes: RouteObject[] = [
    {
        index: true,
        lazy: async () => {
            const { VideoList } = await import('@@routes/externalContent/videos/');

            return { Component: VideoList };
        },
    },
    {
        path: 'new',
        lazy: async () => {
            const { VideoSetupPage } = await import('@@routes/externalContent/videos');

            return { Component: VideoSetupPage };
        },
    },
    {
        path: ':id',
        lazy: async () => {
            const { VideoDetailPage } = await import('@@routes/externalContent/videos');

            return { Component: VideoDetailPage };
        },
        children: [
            {
                index: true,
                lazy: async () => {
                    const { default: Content } =
                        await import('@@routes/externalContent/videos/components/Content');

                    return { Component: Content };
                },
                errorElement: <ErrorPage />,
            },
            metadataRoute,
            pushRoute,
        ],
    },
];
